export function NativeSelect({ className = "", children, ...props }) {
  return (
    <select {...props}
      className={`h-10 w-full rounded-lg border border-[#d1e7dd] bg-white px-3 text-sm text-[#0b2e20] focus:outline-none focus:ring-2 focus:ring-[#2e7d56] ${className}`}>
      {children}
    </select>
  );
}
